/* eslint-disable no-constant-condition */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

// 프로퍼티타입 지정
type PagenationProps = {
  PageInfo: {
    total: number;
    rowCount: number; //  1페이지당 몇개를 노출시키는지
    page: number; // 현재 페이지
    totalPages: number;
    // pageGrp: number;
  };
  IsFirstEndArrow?: boolean;
  PagenationHandler?: (event: any) => void;
};

export function Pagenation(props: PagenationProps) {
  const pageGrp = 10;
  const { PageInfo, PagenationHandler, IsFirstEndArrow } = props;
  const [page, setPage] = useState<number>();

  const [pageGrpNo = 1, setPageGrpNo] = useState<number>();

  useEffect(() => {
    setPagenation();
  }, [PageInfo]);

  const setPagenation = () => {
    const { totalPages, rowCount } = PageInfo;
    const tmp1 = rowCount * pageGrp;
    const tmp2 = rowCount * PageInfo.page;

    setPage(totalPages);
    setPageGrpNo(Math.ceil(tmp2 / tmp1));
  };

  const onClickPgae = (event: any) => {
    let currPage: number = 0;
    switch (event) {
      case 'end':
        currPage = PageInfo.totalPages;
        break;
      case 'prive':
        if (PageInfo.page === 1) currPage = 1;
        else currPage = PageInfo.page - 1;
        break;
      case 'next':
        if (PageInfo.page === PageInfo.totalPages) currPage = PageInfo.page;
        else currPage = PageInfo.page + 1;
        break;
      case 'first':
      default:
        currPage = 1;
        break;
    }

    const pageInfo = { ...PageInfo, page: currPage };
    if (PagenationHandler) {
      PagenationHandler(pageInfo);
    }
  };

  const onClickPageNumber = (clickPage: number) => {
    if (PagenationHandler) {
      PagenationHandler({ ...PageInfo, page: clickPage });
    }
  };
  const SetPageNumber = () => {
    const rtn = [];
    const start = pageGrp * pageGrpNo - (pageGrp - 1);
    const end = pageGrp * pageGrpNo;
    for (let i = start; i <= end && i <= PageInfo.totalPages; i++) {
      rtn.push(
        <Link
          to="#"
          className={` ${PageInfo.page === i ? 'active' : ''}`}
          onClick={() => onClickPageNumber(i)}
          key={i}
        >
          {i}
        </Link>
      );
    }
    return rtn;
  };
  return (
    <div className="table-footer">
      {page === 0 ? (
        <div className="pagenation">
          <span>결과가 없습니다.</span>
        </div>
      ) : (
        <div className="pagenation">
          {IsFirstEndArrow ? (
            <Link to="#" onClick={() => onClickPgae('first')}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
              </svg>
            </Link>
          ) : (
            ''
          )}
          <Link to="#" onClick={() => onClickPgae('prive')}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
            </svg>
          </Link>
          {SetPageNumber()}
          <Link to="#" onClick={() => onClickPgae('next')}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
              <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
            </svg>
          </Link>
          {IsFirstEndArrow ? (
            <Link to="#" onClick={() => onClickPgae('end')}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
              </svg>
            </Link>
          ) : (
            ''
          )}
        </div>
      )}
    </div>
  );
}
